<template>
  <div>
    <el-dialog title="Warning" :visible.sync="show" :show-close="false" :append-to-body="true" width="50%" top="3vh"
      :close-on-click-modal="false" :destroy-on-close="true" @before-close="closePrintModal">
      <div slot="title">
        <div class="title-document"><i class="el-icon-printer"></i> Imprimir</div>
        <div class="title-icon fr"><el-link @click="closePrintModal" :underline="false"><i
              class="el-icon-close"></i></el-link>
        </div>
        <!-- <div class="title-icon fr">
                    <el-button icon="el-icon-printer" size="mini" @click="printDocument" circle></el-button>
                </div> -->
      </div>
      <div id="printSection" class="scrollable only-x">
        <format-one />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" icon="el-icon-printer" :loading="loadingPrint" @click="printDocument">Imprimir</el-button>
        <el-button icon="el-icon-close" @click="closePrintModal">Cerrar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { printPdf } from "@/api/document";
import FormatOne from "@/views/apps/inputOutputAdjust/printsFormat/Format1.vue"
export default {
  name: "PrintComponent",
  components: { FormatOne },
  props: ['show'],
  data() {
    return {
      loadingPrint: false,
    };
  },
  computed: {
    ...mapGetters(['dataPrint'])
  },
  methods: {
    ...mapActions(['inputAndOutputAdjust/setDataPrintAction']),
    closePrintModal() {
      this['inputAndOutputAdjust/setDataPrintAction'](null)
      this.$emit('close')
    },
    printDocument() {
      // window.print();
      let me = this
      me.loadingPrint = true
      printPdf(me.dataPrint.document.id).then(({ data }) => {
        this.$message.success("Documento PDF");
        // window.open(process.env.VUE_APP_ROOT+"storage/documento.pdf");
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
                      width=0,height=0,left=-1000,top=-1000`;
        open(process.env.VUE_APP_ROOT + "storage/documento.pdf", 'DOCUMENT', params);
        me.loadingPrint = false
      }).catch((e) => {
        me.loadingPrint = false
        me.$message.error("Error al generar el documento de impresión.");
        console.log(e);
      })
    }
  }
};
</script>
<style lang="scss">
@media print {
  @page {
    margin: 0px 0px 0px 0px;
  }

  body * {
    visibility: hidden;
  }

  .layout-container {
    visibility: hidden;
  }

  #printSection,
  #printSection * {
    visibility: visible;
  }

  #printSection {
    position: absolute !important;
    left: 0;
    top: -100px;
  }
}

body {
  @media print {
    margin-top: 0px;
    background: #eee;
  }
}

.el-dialog {
  @media print {
    width: 90% !important;
    margin-top: 10vh !important;
  }
}

.title-document {
  font-size: 20px;
  float: left;
}

.title-icon {
  .el-link {
    font-size: 20px;
    margin-left: 10px;
  }
}

@media (max-width: 1100px) {
  .el-dialog {
    width: 70% !important;
  }
}

@media (max-width: 780px) {
  .el-dialog {
    width: 90% !important;
  }
}
</style>